import * as v from 'valibot';
import { EmailAddress } from './credentials.js';
import { identifier, pii } from './domain-string.js';
export const WaitlistName = pii('waitlist-name');
export const WaitlistEntryId = identifier('waitlist-entry-id');
export const WaitlistCustomStudioType = pii('waitlist-custom-studio-type');
import { coercedDate } from './shared.js';
export const WaitlistEntry = v.object({
    id: WaitlistEntryId,
    name: WaitlistName,
    email: EmailAddress,
    // These represent product-defined choices, not user-authored prose.
    studentCount: v.string(),
    studioType: v.string(),
    submittedAt: coercedDate(),
    customStudioType: v.optional(WaitlistCustomStudioType),
    // Involvement levels represent the same product-defined vocabulary.
    betaInvolvementLevels: v.array(v.string()),
});
//# sourceMappingURL=waitlist.js.map